import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HomeService } from './home.service';
import { IUserModel } from 'src/app/models/userModel';
import { IEventUserModel } from 'src/app/models/eventUserModel';
import { AuthService } from 'src/app/services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-home-five',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public eventId: string = "";
  eventRegisterForm: FormGroup;

  public userModel: IUserModel = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: ""
  }

  public eventUserModel: IEventUserModel = {
    eventId: "",
    userId: ""
  };

  public latestBlogsList: Array<any> = [];
  public latestEventsList: Array<any> = [];
  public latestCoursesList: Array<any> = [];


  constructor(private formBuilder: FormBuilder, private _authService: AuthService, private _homeService: HomeService,
    private _ref: ChangeDetectorRef, private _spinner: NgxSpinnerService) {
    this.eventRegisterForm = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  ngOnInit() {
    this.getLatestBlogs();
    this.getLatestEvents();
    this.getLatestCourse();
  }

  getLatestEvents() {
    this._homeService.getLatestEvents().subscribe({
      next: (response: any) => {
        if (response && response.length > 0) this.latestEventsList = response;
        else this.latestEventsList = [];

        setTimeout(() => {
          this._ref.markForCheck();
        }, 1000);
      },
      error: (error) => {
        this.latestEventsList = [];
        this._ref.markForCheck();
        console.log(error);
      },
    });
  }

  getLatestBlogs() {
    this._homeService.getLatestBlogs().subscribe({
      next: (response: any) => {
        if (response && response.length > 0) this.latestBlogsList = response;
        else this.latestBlogsList = [];

        setTimeout(() => {
          this._ref.markForCheck();
        }, 1000);
      },
      error: (error) => {
        this.latestBlogsList = [];
        this._ref.markForCheck();
        console.log(error);
      },
    });
  }

  getLatestCourse() {
    this._homeService.getLatestCourse().subscribe({
      next: (response: any) => {
        if (response && response.length > 0) this.latestCoursesList = response;
        else this.latestCoursesList = [];

        setTimeout(() => {
          this._ref.markForCheck();
        }, 1000);
      },
      error: (error) => {
        this.latestCoursesList = [];
        this._ref.markForCheck();
        console.log(error);
      },
    });
  }

  openEventRegistrationModal(eventId: string) {
    this.eventRegisterForm.reset();
    this.eventId = eventId;
  }

  saveUserRegistration() {
    if (!this.eventRegisterForm.valid) {
      alert("Event registration is not have valid details.");
      this.eventRegisterForm.markAllAsTouched();
      return;
    } else {
      this._spinner.show();
      this.userModel = this.eventRegisterForm.value;
      this._authService.postUserRegistration(this.userModel).subscribe({
        next: (response: any) => {
          if (response && response.hasOwnProperty('_id')) {
            this.eventUserModel = {
              eventId: this.eventId,
              userId: response._id
            };
            this.saveEventRegistration();
          }

          this._spinner.hide();
          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          this._spinner.hide();
          alert(error.error.message);
        },
      });
    }
  }

  saveEventRegistration() {
    this._homeService.postEventUserRegistration(this.eventUserModel).subscribe({
      next: (response: any) => {
        if (response && response.hasOwnProperty('_id')) {
          alert("Event registration successful.");
          this.eventRegisterForm.reset();
          this.getLatestEvents();
        }

        setTimeout(() => {
          this._ref.markForCheck();
        }, 1000);
      },
      error: (error) => {
        this.latestCoursesList = [];
        this._ref.markForCheck();
        console.log(error);
      },
    });
  }
}
